module.exports = __webpack_public_path__ + "img/mockup_final_mobile.c624c07d.png";